import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/ballon.module.scss'

type Props = {
  direction: 'top' | 'right' | 'bottom' | 'left'
  children: ReactNode
}

const Balloon: FC<Props> = (props) => {
  const { direction, children } = props

  return <div className={styles[direction]}>{children}</div>
}

export default Balloon
